export class JSONRepairError extends Error {
  constructor(message, position) {
    super(message + ' at position ' + position);
    this.position = position;
  }
}
//# sourceMappingURL=JSONRepairError.js.map